import { CartModificationPayload, CustomCart, ShareCartPayload } from '@cart/const';
import { Cart, StateUtils } from '@spartacus/core';

export const CART_FEATURE = 'customCart';
export const COMPARE_TYPE = '[CustomCart] Compare';
export const DIFFS = '[CustomCart] Diffs';
export const SHARE_CART_ENTITY = '[CustomCart] Share cart';
export const CLONE_CART_ENTITY = '[CustomCart] Clone Cart';
export const ORGANIZATION_ON_CART = '[CustomCart] Organization on Cart';
export const CART_RETRIEVAL = '[CustomCart] Cart Retrieval';
export const SAVED_CART_LIST_PROCESS_ID = 'saved-cart-list';
export const SAVED_CART_RESTORE_CART_PROCESS_ID = 'saved-cart-restore-cart';
export const SAVED_CART_SAVE_CART_PROCESS_ID = 'saved-cart-save-cart';
export const SAVED_CART_CLONE_CART_PROCESS_ID = 'saved-cart-clone-cart';

export interface StateWithCustomCart {
  [CART_FEATURE]: CustomCartState;
}

export interface CustomCartState {
  cartDiff: StateUtils.LoaderState<CartModificationPayload>;
  shareCart: StateUtils.LoaderState<ShareCartPayload>;
  cloneCart: StateUtils.LoaderState<Cart>;
  organizationToCart: StateUtils.LoaderState<CustomCart>;
  tempCartId: string;
  voucherError: any | null;
}
